var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSol(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_722_32748)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 18C13.9706 18 18 13.9706 18 9C18 4.02944 13.9706 0 9 0C4.02944 0 0 4.02944 0 9C0 13.9706 4.02944 18 9 18Z",
    fill: "#66F9A1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.58283 11.0739C5.64502 11.0126 5.7289 10.9782 5.81626 10.9783H13.8971C13.9297 10.9779 13.9617 10.9872 13.9889 11.0051C14.0162 11.023 14.0374 11.0486 14.0499 11.0787C14.0625 11.1088 14.0657 11.1419 14.0592 11.1739C14.0527 11.2058 14.0368 11.2351 14.0136 11.2579L12.4172 12.8413C12.3551 12.9029 12.2712 12.9374 12.1838 12.9375H4.10289C4.07031 12.9378 4.03839 12.9283 4.01122 12.9104C3.98404 12.8924 3.96285 12.8667 3.95034 12.8366C3.93784 12.8066 3.9346 12.7734 3.94103 12.7415C3.94746 12.7096 3.96328 12.6803 3.98645 12.6574L5.58283 11.0739ZM5.58283 5.15813C5.64502 5.09677 5.7289 5.06241 5.81626 5.0625H13.8971C14.044 5.0625 14.1176 5.23913 14.0136 5.34263L12.4172 6.92606C12.355 6.98742 12.2711 7.02178 12.1838 7.02169H4.10289C4.07043 7.02185 4.03865 7.01236 4.0116 6.99442C3.98455 6.97648 3.96344 6.9509 3.95096 6.92094C3.93848 6.89097 3.93519 6.85797 3.94151 6.82613C3.94783 6.79429 3.96347 6.76505 3.98645 6.74213L5.58283 5.15813ZM12.4172 8.09719C12.355 8.03583 12.2711 8.00147 12.1838 8.00156H4.10289C4.07031 8.00129 4.03839 8.01073 4.01122 8.0287C3.98404 8.04667 3.96285 8.07233 3.95034 8.10242C3.93784 8.1325 3.9346 8.16563 3.94103 8.19756C3.94746 8.2295 3.96328 8.25879 3.98645 8.28169L5.58283 9.86513C5.6447 9.92644 5.72908 9.96075 5.81626 9.96075H13.8971C13.9297 9.96103 13.9616 9.95158 13.9888 9.93361C14.016 9.91565 14.0372 9.88998 14.0497 9.8599C14.0622 9.82981 14.0654 9.79668 14.059 9.76475C14.0526 9.73281 14.0368 9.70352 14.0136 9.68062L12.4172 8.09719Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_722_32748"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSol);
export default __webpack_public_path__ + "static/media/sol.1de9f238e86643e061f7128b0886520a.svg";
export { ForwardRef as ReactComponent };